import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Holding from "../models/Holding"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Button, DialogActions, DialogTitle } from "@mui/material";
import { useMemo, useState } from "react";
import FormGroup from "../libs/form/FormGroup";
import FormControl from "../libs/form/FormControl";
import Validators from "../libs/form/Validators";
import AccountSelect from "../components/AccountSelect";
import PortUtils from "../portlibs/PortUtils";
import { usePath } from "../libs/path/PathProvider";
import { TransactionType } from "../shared/Consts";
import ActionSelect from "./AddHolding/ActionSelect";
import EvalText from "../components/EvalText";
import usePortfolio from "../hooks/PortfolioProvider";
import { Transaction } from "../models/Transaction";
import dayjs from "dayjs";
import GICHolding from "../models/GICHolding";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import { useDialog } from "../libs/dialog/DialogProvider";
import PortAccount from "../models/PortAccount";

function getPayout(holding:Holding) {
    if (holding.isCashEq) return (holding as GICHolding).yield/100
    else return holding.payout
}
export default function Dividend(props:{ticker:string,transaction:Transaction|null}){
    const {portfolio} = usePortfolio()
    const {query} = usePath()
    const account = PortUtils.getFilter(query, 0).account
    const holding = portfolio.holding(props.ticker)?.filterByAccount(account)
    const [busy,setBusy] = useState<boolean>(false)
    const [qty,setQty] = useState<string>(holding ? getPayout(holding)?.toFixed(3) : "0")
    const [currentAccount,setCurrentAccount] = useState<number>(account)
    const [type,setType] = useState<number>(TransactionType.dividend)
    const [date,setDate] = useState<dayjs.Dayjs>(dayjs())
    const {setSnackbar} = useSnackbar()
    const {closeDialog} = useDialog()

    const form = useMemo(() => new FormGroup("add", [
        new FormControl("ticker", [Validators.Required], props.ticker),
        new FormControl("qty", [Validators.NonZero], qty),
    ]), [])

    const gicTransaction = props.transaction && Transaction.isGIC(props.transaction) ? props.transaction : null
    const onSave = async () => {
        if (!form.dirty) form.markAllAsDirty()
        if (!form.valid) return
        else if (busy || !holding) return
        else setBusy(true)

        const trans = gicTransaction ? gicTransaction.clone() : new Transaction(holding, {})
        trans._id = ""
        trans.date = date.toDate()
        trans.quantity = parseFloat(qty)
        trans.price = 1
        trans.note = "Dividend"
        trans.type = type
        try {
            await PortAccount.i.update(portfolio, trans, true, 0)
            closeDialog()
        }catch(e){
            setSnackbar(e)
            setBusy(false)
        }

    }
    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DialogTitle className="flex middle gap-8">{props.ticker}</DialogTitle>
        <div className="content">
            <AccountSelect showAll={false} onSelect={setCurrentAccount} current={currentAccount} key="account"/>
            <ActionSelect current={type} onChange={type => setType(type)} key="type"/>
            <EvalText key="qty" controlName="qty" form={form} placeholder="Quantity" value={qty} onEval={(val)=>setQty(val)} onChange={(e)=>setQty(e.target.value)}/>
            <DatePicker key="date" label="Date" value={date} onChange={(e:any)=>setDate(e)}/>                
        </div>
        <DialogActions>
        <Button onClick={onSave} disabled={busy}>Save</Button>
        </DialogActions>
    </LocalizationProvider>
}